module.exports = __webpack_public_path__ + "4bf8dc890b2632f7e6b90d024c12c380.png";